import React, { FC, useEffect, useState, useMemo } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { observer } from 'mobx-react'
import { IonPage, useIonViewWillEnter } from '@ionic/react'
import { storeMobx, restaurantConfig, restaurantCenter } from 'restaurant'
import { locationMobx, deliveryMobx, themeMobx, buyTogetherMobx, eatTypeStatusMobx } from '@mobxStore'
import { getParams } from '@dt/fe-utils'
import { useHistoryNew, showMsg, alertLayer, getPlatform, miniAppRouteTo } from '@utils'
import { keyBy } from '@dt/fe-utils/dist/lodash'
import BaiduMap from './components/StoreMap/baiduMap'
import GoogleMap from './components/StoreMap/googleMap'
import StoreList from './components/StoreList'
import StoreTop from './components/StoreTop'
import { BackPageBtn } from '@cps'
import './index.scss'
import StoreDeliveryList from './components/StoreDeliveryList'

const { inMiniApp, isWeixinMiniProgram, isAliPayMiniProgram } = getPlatform()

// interface
interface IProps extends IPage, RouteComponentProps {
  mapType?: string;
  locationOBJ: {
    latitude: string;
    longitude: string;
  };
}

/** 选择门店页 */
const Store: FC<IProps> = (props) => {
  const { tt: targetType = '', isDelivery = false } = getParams()
  const { locationIsOpen, getLocation } = locationMobx
  const [isStoreMore, setIsStoreMore] = useState(true)
  const [isSearch, setIsSearch] = useState<boolean>(false)
  const [storeDetail, setStoreDetail] = useState<{}>(false)
  const [isLBS, setIsLBS] = useState<boolean>(true)
  const [locationOBJ, setLocationOBJ] = useState({
    latitude: restaurantConfig.lbs?.lat || 0,
    longitude: restaurantConfig.lbs?.lng || 0
  })
  /** 选中门店后是否不可以返回，是就需要控制跳转点单页 */
  const [showBackBtn, setShowBackBtn] = useState(false)
  /** 选中门店后是否不可以返回，是就需要控制跳转点单页 */
  const [hideBack, setHideBack] = useState(true)
  /** 需要返回的 */
  const targetBack = ['recommend'].includes(targetType)
  // 记住标题
  const [searchTitle, setSearchTitle] = useState<string>(i18n.t('store.storeGoAdd'))
  const eatType = restaurantConfig.mpc.eatType || Config.eatType

  useIonViewWillEnter(() => {
    const hideBack = history.getPrevState() !== '/menu'
    setHideBack(hideBack)
  })
  const history = useHistoryNew()

  let mapType = boJudge.checkKey('mapCn') ? 'baidu' : 'google'

  /** 如果切换门店没有当前就餐方式，就提示 */
  const checkEatType = (store) => {
    if (restaurantConfig.codeType !== 'brand') {
      const hasEatType = eatTypeStatusMobx.checkHasEatTypeInStore(store, eatType)
      !hasEatType && showMsg(i18n.t('store.autoChangeEatTypeTip', { eatType: i18n.t(`menu.${eatType}`) }), 2000)
    }
  }

  const handleBack = () => {
    const isFromMenu = history.getPrevState() === '/menu'

    setShowBackBtn(!!themeMobx?.showTabs?.find(item => item.type === 'home') || !!storeMobx.info.storeId)
    // 选中门店就都返回点单页
    if (storeMobx.info.storeId) {
      if (isFromMenu) {
        history.goBack()
      } else {
        history.replace('/menu')
      }
    } else {
      // 没选中都返回首页, 判断运行环境
      if (inMiniApp) {
        miniAppRouteTo({
          url: '/pages/home/index'
        })
      } else {
        history.replace('/home')
      }
    }
  }

  // 跳转到商铺逻辑，未改动
  const onSelectStore = (store: IViewStore) => {
    const difStore = store.storeId !== restaurantConfig.storeId
    if (restaurantConfig.codeType === 'table') {
      if (difStore) {
        alertLayer({
          message: i18n.t('store.canNotSwitchStoreByTableCode'),
          button: i18n.t('cart.ikonw')
        })
      } else {
        if (targetBack) {
          history.goBack()
        } else if (hideBack) {
          history.replace('/menu')
        } else {
          history.goBack()
        }
      }
    } else {
      // 拼单
      if (targetType === 'buyTogether') {
        // 拼单第一次进入没有选择过门店需要初始化门店
        if (difStore && !storeMobx?.info.storeId) {
          storeMobx.initInfo({
            ...store,
            from: targetType
          })
        }
        buyTogetherMobx.setStore(store)
        history.replace('/menu', null, { tt: targetType })
      } else {
        if (difStore) {
          storeMobx.initInfo({
            ...store,
            from: targetType
          })
          checkEatType(store)
        }
        if (targetBack) {
          history.goBack()
        } else if (targetType === 'checkout') {
          restaurantCenter.init()
          history.replace('/checkout')
        } else {
          if (hideBack) {
            history.replace('/menu', null, { tt: targetType })
          } else {
            if (history.getRouteInfo().routeAction === 'replace') {
              history.replace('/menu', null, { tt: targetType })
              return
            }
            history.goBack()
            if (difStore) {
              setTimeout(() => window.history.replaceState(window.history.state, '', '/menu' + themeMobx.urlSearch), 1000)
            }
          }
        }
      }
    }
    /** 校验已选的地址是否在当前切换门店的配送范围 */
    deliveryMobx.verifyAddress()
  }
  // 切换地址定位
  const onSelectMap = (store) => {
    setStoreDetail(store)
    setLocationOBJ({
      latitude: store.lbsLat,
      longitude: store.lbsLng
    })
  }
  // 是否显示上拉
  const mapShow = (type) => {
    setIsSearch(type)
  }
  const handleStoreClassify: {
    boughtList: IViewStore[];
    moreList: IViewStore[];
  } = useMemo(() => {
    // 拼单外卖门店
    const storeList = targetType === 'buyTogether' ? storeMobx.viewStoreList.filter((item) => {
      if (item.isOpenBuyTogether !== 1) return false
      if (buyTogetherMobx.eatType === 'delivery' && item.openSelfDelivery !== 1) return false
      return true
    }) : storeMobx.viewStoreList

    if (!storeMobx.storeBoughtList.length) {
      return {
        boughtList: [],
        moreList: storeList
      }
    }
    const _boughtObj = keyBy(storeMobx.storeBoughtList, 'storeId')
    const boughtList = []
    const moreList = []
    storeList.forEach(item => {
      const _item = _boughtObj[item.storeId]
      if (targetType === 'buyTogether') {
        if (item.isOpenBuyTogether !== 1) return
        if (buyTogetherMobx.eatType === 'delivery' && item.openSelfDelivery !== 1) return
      }
      if (_item) {
        boughtList.push({
          ...item,
          boughtCnt: _item.cnt
        })
      } else {
        moreList.push({
          ...item,
          boughtCnt: 0
        })
      }
    })
    return {
      boughtList,
      moreList
    }
  }, [storeMobx.viewStoreList, storeMobx.storeBoughtList])
  const setLBS = (res) => {
    if (res && res?.latitude && res?.longitude) {
      locationMobx.setLocationIsOpen(true)
      locationMobx.setLocation({
        ...res
      })
      setLocationOBJ(res)
      setIsLBS(true)
    }
  }
  useEffect(() => {
    if (storeMobx.info?.storeId) {
      setLocationOBJ({ latitude: storeMobx.info.lbsLat, longitude: storeMobx.info.lbsLng })
      setStoreDetail(storeMobx.info)
      !locationOBJ.latitude && !locationOBJ.longitude && setIsLBS(false)
    } else {
      if (!locationIsOpen) {
        setIsLBS(false)
        getLocation().then(res => setLBS(res))
      }
    }
    /** 开启首页，或者选择了门店才展示返回，否则不可返回 */
    setShowBackBtn(!!themeMobx?.showTabs?.find(item => item.type === 'home') || !!storeMobx.info.storeId)
  }, [])
  return (
    <IonPage className='store-page'>
      {!isLBS && !isSearch ? <StoreTop setLBS={setLBS} /> : null}
      {showBackBtn && <BackPageBtn top={!isLBS ? 30 : 0} onClick={handleBack} />}
      <div className='bg'>
        {
          mapType === 'baidu' ? (
            <BaiduMap
              mapShow={mapShow}
              setSearchTitle={setSearchTitle}
              isLBS={isLBS}
              setLBS={setLBS}
              isSearch={isSearch}
              isStoreMore={isStoreMore}
              setIsStoreMore={setIsStoreMore}
              location={locationOBJ}
              handleStoreClassify={handleStoreClassify}
              storeDetail={storeDetail}
              onSelectStore={onSelectStore}
            />
          ) : (
            <GoogleMap
              isSearch={isSearch}
              mapShow={mapShow}
              setIsStoreMore={setIsStoreMore}
              setSearchTitle={setSearchTitle}
              location={locationOBJ}
              storeDetail={storeDetail}
              onSelectStore={onSelectStore}
              handleStoreClassify={handleStoreClassify}
            />
          )
        }
      </div>
      {isDelivery ? (
        <StoreDeliveryList
          isLBS={isLBS}
          targetType={targetType}
          onSelectMap={onSelectMap}
          mapShow={mapShow}
          searchTitle={searchTitle}
          onSelectStore={onSelectStore}
          isStoreMore={isStoreMore}
          setIsStoreMore={setIsStoreMore}
        />
      ) : (
        <StoreList
          isLBS={isLBS}
          targetType={targetType}
          onSelectMap={onSelectMap}
          mapShow={mapShow}
          searchTitle={searchTitle}
          onSelectStore={onSelectStore}
          isStoreMore={isStoreMore}
          setIsStoreMore={setIsStoreMore}
        />
      )}
    </IonPage>
  )
}

export default observer(Store)
